// import nl2br from "react-newline-to-break";
import { canNodeBeMovedOrResized, findSubNode, getCustomisationValue, updateCustomisationValue } from "../EditablePreview";
import { useEffect, useState } from "react";
import { COLOUR_NAME_TO_COLOUR_HEX, HEX_TO_RGBA } from "../../../../../../helpers/Colours";
import { CUSTOM_COMPONENTS_LIST } from "./CustomComponentsList";

export const WORKING_ON_NODE_DATA = {
    visualisedNodeVarKey: null,
    fieldData: null,
    campaignData: null,
}

export const IMAGE_MODES = {
    fillArea: 'fillArea',
    naturalSize: 'naturalSize',
    scaled: 'scaled',
}

const newline = '\n';

function nl2br(text) {
    if (typeof text === 'number') {
        return text;
    } else if (typeof text !== 'string') {
        return '';
    }

    let lines = text.split(newline);
    return lines.map(function(line, i) {
        return (
            <span key={i}>
                {line}
                {i !== lines.length - 1 &&
                    <br/>
                }
            </span>
        );
    });
}

const getCustomModuleContent = (moduleData, customisationVars, imageMode, previewScale, index = 0, node = null, contentStyleObj = null, applyScale = 1, refreshContent = false, applyRotation = null) => {
    // console.log("Getting custom module content for moduleData:", moduleData, customisationVars);
    const content = [];
    let imageScaleValue = null;
    // If applyScale is the default value then we are going to automatically apply any scale fields we find, but only to images
    if (applyScale === 1) {
        for (let i = 0; i < moduleData.fields.length; i++) {
            const field = moduleData.fields[i];
            // console.log("Looking for scale field, processing field:", field);
            if (field?.customFieldConfig?.customFieldLabel?.startsWith('Scale') && field.customFieldConfig.dataLink) {
                imageScaleValue = getCustomisationValue(customisationVars, field.customFieldConfig.dataLink, index, null, node) ?? 100;
            }
        }
    }
    for (let i = 0; i < moduleData.fields.length; i++) {
        // console.log("Processing field:", moduleData.fields[i]);
        const field = moduleData.fields[i];
        switch (field?.customFieldConfig?.customFieldType) {
            case 'ImageUpload':
                // console.log("Found ImageUpload field:", field, imageMode);
                if (field.customFieldConfig.dataLink) {
                    const imageData = getCustomisationValue(customisationVars, field.customFieldConfig.dataLink, index, null, node);
                    // console.log(`Image URL from customisationVars ${field.customFieldConfig.dataLink}:`, imageData);
                    if (imageData) {
                        let imageStyle = {
                            width: '100%',
                            height: '100%',
                        };
                        if (imageMode === IMAGE_MODES.naturalSize) {
                            imageStyle.width = imageData.naturalWidth ? (imageData.naturalWidth * previewScale) + 'px' : 'auto';
                            imageStyle.height = imageData.naturalHeight ? (imageData.naturalHeight * previewScale) + 'px' : 'auto';
                        } else
                        if (imageMode === IMAGE_MODES.scaled) {
                            imageStyle.width = imageData.naturalWidth ? (imageData.naturalWidth * applyScale * previewScale) + 'px' : '0px';
                            imageStyle.height = imageData.naturalHeight ? (imageData.naturalHeight * applyScale * previewScale) + 'px' : '0px';
                        }
                        // console.log("Image style before mode adjustments:", imageStyle, field, imageMode);
                        // We might need this stuff, so leaving it in and commented out for now
                        /* if (imageMode === IMAGE_MODES.naturalSize) {
                            if (contentStyleObj) {
                                contentStyleObj.transformOrigin = 'center center';
                                contentStyleObj.transform = `scale(${previewScale})`;
                            } else {
                                imageStyle.transformOrigin = 'center center';
                                imageStyle.transform = `scale(${previewScale})`;
                            }
                        } */
                        // switched to using onLoad to set image size to avoid issues with bounding box size calculation
                        const onImageLoaded = (e) => {
                            // Get the natural width and height of the image
                            const naturalWidth = e.target.naturalWidth;
                            const naturalHeight = e.target.naturalHeight;
                            imageData.naturalWidth = naturalWidth;
                            imageData.naturalHeight = naturalHeight;
                            // console.log("Image style natural size:", naturalWidth, naturalHeight, field, imageMode);
                            /* contentStyleObj.transformOrigin = null;
                            contentStyleObj.transform = null;
                            imageStyle.transformOrigin = null;
                            imageStyle.transform = null; */
                            // imageStyle.width = `${naturalWidth * previewScale}px`;
                            // imageStyle.height = `${naturalHeight * previewScale}px`;
                            // Set the width and height of the image based on the mode
                            if (imageMode === IMAGE_MODES.scaled) {
                                // Let the CSS handle it
                                e.target.style.width = `${naturalWidth * applyScale * previewScale}px`;
                                e.target.style.height = `${naturalHeight * applyScale * previewScale}px`;
                            } else
                            if (imageMode === IMAGE_MODES.naturalSize) {
                                e.target.style.width = `${naturalWidth * previewScale}px`;
                                e.target.style.height = `${naturalHeight * previewScale}px`;
                            } else {
                                // Not sure if this part is right
                                e.target.style.width = `100%`;
                                e.target.style.height = `100%`;
                            }
                        }

                        if (typeof applyRotation === 'number') {
                            imageStyle.transform = `rotate(${applyRotation}deg)`;
                        }
                        if (imageScaleValue) {
                            imageStyle.transform = imageStyle.transform ? `${imageStyle.transform} scale(${imageScaleValue / 100})` : `scale(${imageScaleValue / 100})`;
                            imageStyle.transformOrigin = 'center center';
                        }

                        content.push(
                            <img key={i + (refreshContent ? '_r' : '')} src={imageData.srcUrl} alt={imageData.filename} onLoad={onImageLoaded} className={`v2-custom-image${imageMode === IMAGE_MODES.fillArea ? ' v2-100-image' : ''}`} style={imageStyle} />
                        );
                    }
                } else {
                    console.warn("ImageUpload field does not have a dataLink:", field);
                }
                break;
            case 'VideoUpload':
                // Similar to image upload but with a video tag
                if (field.customFieldConfig.dataLink) {
                    const videoData = getCustomisationValue(customisationVars, field.customFieldConfig.dataLink, index, null, node);
                    if (videoData) {
                        let videoStyle = {
                            width: '100%',
                            height: '100%',
                        };
                        content.push(
                            <video key={i + `_${index}_` + (refreshContent ? '_r' : '')} style={videoStyle} controls>
                                <source src={videoData.srcUrl} />
                            </video>
                        );
                    }
                } else {
                    console.warn("VideoUpload field does not have a dataLink:", field);
                }
                break;
            default:
                // console.warn(`Unknown custom field type: ${field?.customFieldConfig?.customFieldType} for field:`, field);
                // For other types, we can just return the value as text
                /* if (field.dataLink) {
                    const value = getCustomisationValue(customisationVars, field.dataLink);
                    console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
                    if (value) {
                        content.push(<span key={i} className='v2-custom-text'>{value}</span>);
                    }
                } else {
                    console.warn("Field does not have a dataLink:", field);
                } */
                break;
        }
    }
    return content;
}

const updateNodeStyleTransform = (nodeStyle, stringToAdd) => {
    if (nodeStyle.transform) {
        nodeStyle.transform += ` ${stringToAdd}`;
    } else {
        nodeStyle.transform = stringToAdd;
    }
    // console.log("Updated nodeStyle transform:", nodeStyle.transform);
}

const addPositionStyle = (moduleData, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0, applyScale = 1, forcePosition = null, intialXOffset = 0, intialYOffset = 0) => {
    // console.log("Adding position style for moduleData:", moduleData, nodeStyle, customisationVars);
    let foundPositionValueKey = forcePosition ?? 'top-left-value';
    let gotPositionsSetUp = false;
    let gotOffsetSetUp = false;
    let offsetX = 0;
    let offsetY = 0;
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            gotPositionsSetUp = true;
            const value = getCustomisationValue(customisationVars, node?.overrideVisualisedDataLinks?.position ? node.overrideVisualisedDataLinks.position : field.dataLink, typeof node?.overrideVisualisedDataLinks?.positionDataIndex !== 'undefined' ? node.overrideVisualisedDataLinks.positionDataIndex : index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value && field.field?.includes('position-position') && node?.dontVisualiseModuleSettings?.position?.position !== true) {
                for (const key in field) {
                    if (field[key] === value) {
                        foundPositionValueKey = key;
                        break;
                    }
                }
                /* if (foundPositionValueKey) {
                    switch (foundPositionValueKey) {
                        case 'top-left-value':
                            nodeStyle.left = `0`;
                            nodeStyle.top = `0`;
                            break;
                        case 'top-right-value':
                            nodeStyle.right = `0`;
                            nodeStyle.top = `0`;
                            break;
                        case 'top-center-value':
                            nodeStyle.left = `${1920 / 2}px`; // Assuming a 1920px wide preview window
                            nodeStyle.top = `0`;
                            updateNodeStyleTransform(nodeStyle, `translateX(-50%)`);
                            break;
                        case 'center-left-value':
                            nodeStyle.left = `0`;
                            nodeStyle.top = `50%`;
                            updateNodeStyleTransform(nodeStyle, `translateY(-50%)`);
                            break;
                        case 'center-right-value':
                            nodeStyle.right = `0`;
                            nodeStyle.top = `50%`;
                            updateNodeStyleTransform(nodeStyle, `translateY(-50%)`);
                            break;
                        case 'center-value':
                            nodeStyle.left = `50%`;
                            nodeStyle.top = `50%`;
                            updateNodeStyleTransform(nodeStyle, `translate(-50%, -50%)`);
                            break;
                        case 'bottom-left-value':
                            nodeStyle.left = `0`;
                            nodeStyle.bottom = `0`;
                            break;
                        case 'bottom-right-value':
                            nodeStyle.right = `0`;
                            nodeStyle.bottom = `0`;
                            break;
                        case 'bottom-center-value':
                            nodeStyle.left = `50%`;
                            nodeStyle.bottom = `0`;
                            updateNodeStyleTransform(nodeStyle, `translateX(-50%)`);
                            break;
                        default:
                            console.warn(`Unknown position value key: ${foundPositionValueKey}`);
                            break;
                    }
                } */
            }
        } else {
            if (field.field?.includes('position-offset') && node?.dontVisualiseModuleSettings?.position?.offset !== true) {
                // console.log("Processing field:", field);
                // let offsetX = null;
                // let offsetY = null;
                if (field["offset-x"] && field["offset-x"].dataLink) {
                    offsetX = getCustomisationValue(customisationVars, node?.overrideVisualisedDataLinks?.offsetX ? node.overrideVisualisedDataLinks.offsetX : field["offset-x"].dataLink, typeof node?.overrideVisualisedDataLinks?.offsetXDataIndex !== 'undefined' ? node.overrideVisualisedDataLinks.offsetXDataIndex : index, forceComponentVarKey, node) * applyScale;
                    // console.log(`Offset X value from customisationVars ${field["offset-x"].dataLink}:`, offsetX);
                    gotOffsetSetUp = true;
                }
                if (field["offset-y"] && field["offset-y"].dataLink) {
                    offsetY = getCustomisationValue(customisationVars, node?.overrideVisualisedDataLinks?.offsetY ? node.overrideVisualisedDataLinks.offsetY : field["offset-y"].dataLink, typeof node?.overrideVisualisedDataLinks?.offsetYDataIndex !== 'undefined' ? node.overrideVisualisedDataLinks.offsetYDataIndex : index, forceComponentVarKey, node) * applyScale;
                    // console.log(`Offset Y value from customisationVars ${field["offset-y"].dataLink}:`, offsetY);
                    gotOffsetSetUp = true;
                }
                // Use transform to apply offsets
                /* if (offsetX !== null || offsetY !== null) {
                    updateNodeStyleTransform(nodeStyle, `translate(${(offsetX ?? 0) * previewScale}px, ${(offsetY ?? 0) * previewScale}px`);
                } */
            }
        }
    }
    offsetX += intialXOffset;
    offsetY += intialYOffset;
    // We now have the position value and offsets, we can apply them to the nodeStyle
    if (gotPositionsSetUp || gotOffsetSetUp) {
        nodeStyle.position = 'absolute'; // Ensure the node is positioned absolutely
    }
    switch (foundPositionValueKey) {
        case 'top-left-value':
            nodeStyle.left = `${offsetX * previewScale}px`;
            nodeStyle.top = `${offsetY * previewScale}px`;
            break;
        case 'top-right-value':
            nodeStyle.right = `${-offsetX * previewScale}px`;
            nodeStyle.top = `${offsetY * previewScale}px`;
            break;
        case 'top-center-value':
            nodeStyle.left = `${(1920 / 2 + offsetX) * previewScale}px`; // Assuming a 1920px wide preview window
            nodeStyle.top = `${offsetY * previewScale}px`;
            updateNodeStyleTransform(nodeStyle, `translate(-50%, 0)`);
            break;
        case 'center-left-value':
            nodeStyle.left = `${offsetX * previewScale}px`;
            nodeStyle.top = `${(1080 / 2 + offsetY) * previewScale}px`; // Assuming a 1080px high preview window
            updateNodeStyleTransform(nodeStyle, `translate(0, -50%)`);
            break;
        case 'center-right-value':
            nodeStyle.right = `${-offsetX * previewScale}px`;
            nodeStyle.top = `${(1080 / 2 + offsetY) * previewScale}px`; // Assuming a 1080px high preview window
            updateNodeStyleTransform(nodeStyle, `translate(0, -50%)`);
            break;
        case 'center-value':
            nodeStyle.left = `${(1920 / 2 + offsetX) * previewScale}px`; // Assuming a 1920px wide preview window
            nodeStyle.top = `${(1080 / 2 + offsetY) * previewScale}px`; // Assuming a 1080px high preview window
            updateNodeStyleTransform(nodeStyle, `translate(-50%, -50%)`);
            break;
        case 'bottom-left-value':
            nodeStyle.left = `${offsetX * previewScale}px`;
            nodeStyle.bottom = `${-offsetY * previewScale}px`;
            break;
        case 'bottom-right-value':
            nodeStyle.right = `${-offsetX * previewScale}px`;
            nodeStyle.bottom = `${-offsetY * previewScale}px`;
            break;
        case 'bottom-center-value':
            nodeStyle.left = `${(1920 / 2 + offsetX) * previewScale}px`; // Assuming a 1920px wide preview window
            nodeStyle.bottom = `${-offsetY * previewScale}px`;
            updateNodeStyleTransform(nodeStyle, `translate(-50%, 0)`);
            break;
        default:
            console.warn(`Unknown position value key: ${foundPositionValueKey}`);
            break;
    }

    // console.log("Final nodeStyle after position style:", nodeStyle);
}

const addDimensionsStyle = (moduleData, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0, applyScale = 1) => {
    // console.log("Adding dimensions style for moduleData:", moduleData, nodeStyle, customisationVars);
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field["dimensions-height"] && field["dimensions-height"].dataLink && node?.dontVisualiseModuleSettings?.dimensions?.height !== true) {
            const heightValue = getCustomisationValue(customisationVars, field["dimensions-height"].dataLink, index, forceComponentVarKey, node) * applyScale;
            // console.log(`Height value from customisationVars ${field["dimensions-height"].dataLink}:`, heightValue);
            nodeStyle.height = !isNaN(heightValue) ? heightValue * previewScale : null; // Adjust height based on preview scale
        }
        if (field["dimensions-width"] && field["dimensions-width"].dataLink && node?.dontVisualiseModuleSettings?.dimensions?.width !== true) {
            const widthValue = getCustomisationValue(customisationVars, field["dimensions-width"].dataLink, index, forceComponentVarKey, node) * applyScale;
            // console.log(`Width value from customisationVars ${field["dimensions-width"].dataLink}:`, widthValue);
            nodeStyle.width = !isNaN(widthValue) ? widthValue * previewScale : null; // Adjust width based on preview scale
        }
    }
}

const addAppearanceStyle = (moduleData, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0, applyScale = 1) => {
    // console.log("Adding appearance style for moduleData:", moduleData, nodeStyle, customisationVars);
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value) {
                switch (field.field) {
                    case 'customisation-module-appearance-opacity':
                        if (node?.dontVisualiseModuleSettings?.appearance?.opacity !== true) {
                            nodeStyle.opacity = parseFloat(value) / 100;
                        }
                        break;
                    case 'customisation-module-appearance-corner-radius':
                        if (node?.dontVisualiseModuleSettings?.appearance?.cornerRadius !== true) {
                            nodeStyle.borderRadius = `${value * previewScale * applyScale}px`; // Adjust corner radius based on preview scale
                        }
                        break;
                    default:
                        console.warn(`Unknown appearance field: ${field.field}`);
                        break;
                }
            }
        }
    }
}

const addBorderStyle = (moduleData, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0, applyScale = 1) => {
    // console.log("Adding border style for moduleData:", moduleData, nodeStyle, customisationVars);
    let opacity = null;
    // Make sure we extract the fill opacity first
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value) {
                if (field.field === 'customisation-module-border-opacity') {
                    if (node?.dontVisualiseModuleSettings?.border?.opacity !== true) {
                        opacity = parseFloat(value);
                    }
                }
            }
        }
    }

    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value) {
                switch (field.field) {
                    case 'customisation-module-border-thickness':
                        if (node?.dontVisualiseModuleSettings?.border?.thickness !== true) {
                            nodeStyle.borderWidth = `${Math.ceil(value * previewScale * applyScale)}px`; // Adjust border thickness based on preview scale
                            nodeStyle.borderStyle = 'solid'; // Ensure border style is set
                        }
                        break;
                    case 'customisation-module-border-color':
                        if (node?.dontVisualiseModuleSettings?.border?.color !== true) {
                            nodeStyle.borderColor = HEX_TO_RGBA(COLOUR_NAME_TO_COLOUR_HEX(value, campaignData), (opacity ?? 100) / 100); // Assuming value is a valid CSS color
                        }
                        break;
                    // Should also support border opacity amd inner/outer border styles
                    case 'customisation-module-border-opacity':
                        /* nodeStyle.borderOpacity = parseFloat(value);
                        if (nodeStyle.borderColor) {
                            nodeStyle.borderColor = `rgba(${nodeStyle.borderColor}, ${nodeStyle.borderOpacity})`;
                        } */
                        break;
                    case 'customisation-module-border-position':
                        // Assuming value is a string like 'inner' or 'outer'
                        /* if (value === 'inner') {
                            nodeStyle.boxShadow = `inset 0 0 0 ${nodeStyle.borderWidth} ${nodeStyle.borderColor}`;
                        } else if (value === 'outer') {
                            nodeStyle.boxShadow = `0 0 0 ${nodeStyle.borderWidth} ${nodeStyle.borderColor}`;
                        } else {
                            console.warn(`Unknown border position value: ${value}`);
                        } */
                        break;
                    default:
                        console.warn(`Unknown border field: ${field.field}`);
                        break;
                }
            }
        }
    }
}

const addFillStyle = (moduleData, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0) => {
    // console.log("Adding fill style for moduleData:", moduleData, nodeStyle, customisationVars);
    let fillColor = null;
    let fillOpacity = null;

    // Make sure we extract the fill opacity first
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value) {
                if (field.field === 'customisation-module-fill-opacity') {
                    if (node?.dontVisualiseModuleSettings?.fill?.opacity !== true) {
                        fillOpacity = parseFloat(value);
                    }
                }
            }
        }
    }
    // Now we can extract everything else because our fillOpacity is set
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}: `, value);
            if (value) {
                /* if (field.field === 'customisation-module-fill-opacity') {
                    fillOpacity = parseFloat(value);
                } */
            }
        } else {
            // The actual fill colour (or image) is more complicated by the fact we support 4 types, gradient, image, solid colour and stripe
            // More data fields are embedd into these fields which are only relevant id the types dataLink value attribute matches it's value attribute
            if (field.field === 'customisation-module-fill-type' && node?.dontVisualiseModuleSettings?.fill?.type !== true) {
                // console.log("Processing fill type field:", field);
                const types = ['solid', 'gradient', 'image', 'stripes'];
                let typeConfig = null;
                let type = null;
                let unlinkedValue = field['customisation-module-fill-type-unlinked-value']?.enumValue;
                for (const typeString of types) {
                    if (unlinkedValue && field['customisation-module-fill-type-' + typeString] && field['customisation-module-fill-type-' + typeString].name === unlinkedValue) {
                        // We are forcing this type to be used, so we don't need to check the dataLink
                        typeConfig = field['customisation-module-fill-type-' + typeString];
                        type = typeString;
                        // console.log(`Found forced fill type: ${type}`);
                    } else
                        if (field['customisation-module-fill-type-' + typeString] && field['customisation-module-fill-type-' + typeString].dataLink) {
                            const typeValue = getCustomisationValue(customisationVars, field['customisation-module-fill-type-' + typeString].dataLink, index, forceComponentVarKey, node);
                            // console.log(`Fill type ${typeString} value from customisationVars ${field['customisation-module-fill-type-' + typeString].dataLink} (${field['customisation-module-fill-type-' + typeString].value}):`, typeValue);
                            if (typeValue === field['customisation-module-fill-type-' + typeString].value ||
                                (field['customisation-module-fill-type-' + typeString].value?.toLowerCase() === 'true' && typeValue === true) ||
                                (field['customisation-module-fill-type-' + typeString].value?.toLowerCase() === 'false' && typeValue === false)
                            ) {
                                typeConfig = field['customisation-module-fill-type-' + typeString];
                                type = typeString;
                                // console.log(`Found matching fill type: ${type}`);
                                break; // Found the matching type, no need to check others
                            }
                        }
                }
                if (type === 'solid') {
                    if (typeConfig?.options && typeConfig.options['customisation-module-fill-type-solid-options-color'] && typeConfig.options['customisation-module-fill-type-solid-options-color'].dataLink) {
                        fillColor = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-solid-options-color'].dataLink, index, forceComponentVarKey, node);
                        // console.log(`Fill color from customisationVars ${typeConfig.options['customisation-module-fill-type-solid-options-color'].dataLink}:`, fillColor);
                        if (fillColor) {
                            // This shouldn't be set here
                            fillColor = COLOUR_NAME_TO_COLOUR_HEX(fillColor, campaignData);
                            nodeStyle.backgroundColor = fillColor; // Set the background color
                            if (fillOpacity !== null) {
                                nodeStyle.backgroundColor = HEX_TO_RGBA(fillColor, fillOpacity / 100); // Apply opacity if available
                            }
                        }
                    } else {
                        // console.warn("No fill color found for solid type");
                        nodeStyle.backgroundColor = 'transparent'; // Default to transparent if no color is found
                    }
                }
                if (type === 'gradient') {
                    if (typeConfig?.options && typeConfig.options['customisation-module-fill-type-gradient-options-color1'] && typeConfig.options['customisation-module-fill-type-gradient-options-color1'].dataLink) {
                        const gradientAngle = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-gradient-options-angle']?.dataLink, index, forceComponentVarKey, node) ?? 'to bottom'; // Default angle if not specified
                        const gradientColor1 = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-gradient-options-color1'].dataLink, index, forceComponentVarKey, node);
                        // console.log(`Gradient color 1 from customisationVars ${typeConfig.options['customisation-module-fill-type-gradient-options-color1'].dataLink}:`, gradientColor1);
                        if (gradientColor1) {
                            nodeStyle.backgroundImage = `linear-gradient(${gradientAngle}${gradientAngle !== 'to bottom' ? 'deg' : ''}, ${HEX_TO_RGBA(COLOUR_NAME_TO_COLOUR_HEX(gradientColor1, campaignData), (fillOpacity ?? 100) / 100)}`;
                            if (typeConfig.options['customisation-module-fill-type-gradient-options-color2'] && typeConfig.options['customisation-module-fill-type-gradient-options-color2'].dataLink) {
                                const gradientColor2 = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-gradient-options-color2'].dataLink, index, forceComponentVarKey, node);
                                // console.log(`Gradient color 2 from customisationVars ${typeConfig.options['customisation-module-fill-type-gradient-options-color2'].dataLink}:`, gradientColor2);
                                if (gradientColor2) {
                                    nodeStyle.backgroundImage += `, ${HEX_TO_RGBA(COLOUR_NAME_TO_COLOUR_HEX(gradientColor2, campaignData), (fillOpacity ?? 100) / 100)}`;
                                }
                            }
                            nodeStyle.backgroundImage += ')'; // Close the linear gradient
                        }
                    } else {
                        console.warn("No fill colors found for gradient type");
                        nodeStyle.backgroundImage = 'none'; // Default to no background image if no colors are found
                    }
                }
                if (type === 'image') {
                    let imageFillStyle = 'cover'; // Default to cover style
                    if (typeConfig?.options && typeConfig.options['customisation-module-fill-type-image-options-style']) {
                        if (typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-cover-style"]?.dataLink) {
                            const styleValue = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-cover-style"].dataLink, index, forceComponentVarKey, node);
                            const valueNeeded = typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-cover-style"].value;
                            // console.log(`Image fill style from customisationVars ${typeConfig.options['customisation
                            if (styleValue === valueNeeded ||
                                (valueNeeded?.toLowerCase() === 'true' && styleValue === true) ||
                                (valueNeeded?.toLowerCase() === 'false' && styleValue === false)) {
                                imageFillStyle = 'cover'; // Use cover style
                            }
                        }
                        // Contain style
                        if (typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-contain-style"]?.dataLink) {
                            const styleValue = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-contain-style"].dataLink, index, forceComponentVarKey, node);
                            const valueNeeded = typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-contain-style"].value;
                            // console.log(`Image fill style from customisationVars ${typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-contain-style"].dataLink}:`, styleValue);
                            if (styleValue === valueNeeded ||
                                (valueNeeded?.toLowerCase() === 'true' && styleValue === true) ||
                                (valueNeeded?.toLowerCase() === 'false' && styleValue === false)) {
                                imageFillStyle = 'contain'; // Use contain style
                            }
                        }
                        // Tiled style
                        if (typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-tiled-style"]?.dataLink) {
                            const styleValue = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-tiled-style"].dataLink, index, forceComponentVarKey, node);
                            const valueNeeded = typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-tiled-style"].value;
                            // console.log(`Image fill style from customisationVars ${typeConfig.options['customisation-module-fill-type-image-options-style']["customisation-module-fill-type-image-options-tiled-style"].dataLink}:`, styleValue);
                            if (styleValue === valueNeeded ||
                                (valueNeeded?.toLowerCase() === 'true' && styleValue === true) ||
                                (valueNeeded?.toLowerCase() === 'false' && styleValue === false)) {
                                imageFillStyle = 'repeat'; // Use tiled style
                            }
                        }
                    }
                    if (typeConfig?.options && typeConfig.options['customisation-module-fill-type-image-options-image'] && typeConfig.options['customisation-module-fill-type-image-options-image'].dataLink) {
                        const imageData = getCustomisationValue(customisationVars, typeConfig.options['customisation-module-fill-type-image-options-image'].dataLink, index, forceComponentVarKey, node);
                        // console.log(`Image data from customisationVars ${typeConfig.options['customisation-module-fill-type-image-options-image'].dataLink}:`, imageData);
                        if (imageData) {
                            nodeStyle.backgroundImage = `url(${imageData.srcUrl})`; // Set the background image
                            nodeStyle.backgroundSize = imageFillStyle; // Ensure the image covers the entire node
                            nodeStyle.backgroundPosition = 'center'; // Center the image
                        }
                    } else {
                        console.warn("No fill image found for image type");
                        nodeStyle.backgroundImage = 'none'; // Default to no background image if no image is found
                    }
                    nodeStyle.opacity = (fillOpacity !== null) ? (fillOpacity / 100) : 1;
                }
            }
        }
    }
}

const addPaddingStyle = (moduleData, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0, applyScale = 1) => {
    // console.log("Adding padding style for moduleData:", moduleData, nodeStyle, customisationVars);
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value) {
                if (field.field === 'customisation-module-padding-top') {
                    nodeStyle.paddingTop = `${value * previewScale * applyScale}px`; // Adjust padding based on preview scale
                }
                if (field.field === 'customisation-module-padding-right') {
                    nodeStyle.paddingRight = `${value * previewScale * applyScale}px`; // Adjust padding based on preview scale
                }
                if (field.field === 'customisation-module-padding-bottom') {
                    nodeStyle.paddingBottom = `${value * previewScale * applyScale}px`; // Adjust padding based on preview scale
                }
                if (field.field === 'customisation-module-padding-left') {
                    nodeStyle.paddingLeft = `${value * previewScale * applyScale}px`; // Adjust padding based on preview scale
                }
            }
        }
    }
}

const addTypographyStyle = (moduleData, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0, applyScale = 1) => {
    // console.log("Adding typography style for moduleData:", moduleData, nodeStyle, customisationVars);
    for (let i = 0; i < moduleData.fields.length; i++) {
        const field = moduleData.fields[i];
        // console.log("Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value) {
                switch (field.field) {
                    case 'customisation-module-typography-size':
                        if (node?.dontVisualiseModuleSettings?.typography?.size !== true) {
                            nodeStyle.fontSize = `${value * previewScale * applyScale}px`; // Adjust font size based on preview scale
                        }
                        break;
                    /* case 'customisation-module-typography-font':
                        nodeStyle.fontFamily = getCustomisationValue(customisationVars, field?.["customisation-module-typography-font-face"]?.dataLink); // value; // Assuming value is a valid CSS font family
                        break; */
                    case 'customisation-module-typography-text-color':
                        if (node?.dontVisualiseModuleSettings?.typography?.color !== true) {
                            nodeStyle.color = COLOUR_NAME_TO_COLOUR_HEX(value, campaignData) || ''; // Assuming value is a valid CSS color
                        }
                        break;
                    case 'customisation-module-typography-line-height':
                        if (node?.dontVisualiseModuleSettings?.typography?.lineHeight !== true) {
                            nodeStyle.lineHeight = `${value * previewScale * applyScale}px`; // Adjust line height based on preview scale
                        }
                        break;
                    
                    default:
                        console.warn(`Unknown typography field: ${field.field}`);
                        break;
                }
            }
        } else {
            if (field.field === 'customisation-module-typography-font' && node?.dontVisualiseModuleSettings?.typography?.font !== true) {
                nodeStyle.fontFamily = getCustomisationValue(customisationVars, field?.["customisation-module-typography-font-face"]?.dataLink, index, forceComponentVarKey, node).split(' ').join('');
                let fontWeight = 'normal'; // Default font weight
                if (field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-bold"]?.isDefault ||
                    (field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-bold"]?.value 
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-bold"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-bold"]?.value?.toLowerCase())
                ) {
                    fontWeight = 'bold'; // Use bold font weight
                }
                // Narrow
                if (field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-narrow"]?.isDefault ||
                    (field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-narrow"]?.value 
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-narrow"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-narrow"]?.value?.toLowerCase())
                ) {
                    fontWeight = 'narrow'; // Use narrow font weight
                }
                // Normal
                if (field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-normal"]?.isDefault ||
                    (field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-normal"]?.value
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-normal"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-font-weight"]?.["customisation-module-typography-font-weight-normal"]?.value?.toLowerCase())
                ) {
                    fontWeight = 'normal'; // Use normal font weight
                }
                // if (!nodeStyle.fontWeight) {
                    nodeStyle.fontWeight = fontWeight; // Set the font weight
                // }
            }
            if (field.field === 'customisation-module-typography-text-alignment' && node?.dontVisualiseModuleSettings?.typography?.textAlignment !== true) {
                let textAlign = 'left'; // Default alignment
                if (field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.left"]?.isDefault ||
                    (field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.left"]?.value
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.left"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.left"]?.value?.toLowerCase())
                ) {
                    textAlign = 'left';
                }
                if (field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.center"]?.isDefault ||
                    (field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.center"]?.value
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.center"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.center"]?.value?.toLowerCase())
                ) {
                    textAlign = 'center';
                }
                if (field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.right"]?.isDefault ||
                    (field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.right"]?.value
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.right"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-text-alignment.horizontal"]?.["customisation-module-typography-text-alignment-horizontal.right"]?.value?.toLowerCase())
                ) {
                    textAlign = 'right';
                }
                nodeStyle.textAlign = textAlign; // Set the text alignment
                // We also need to set the flex alignment based on the horizontal alignment as our nodeStyle is flexbox based and our text node might not be 100% width
                /* if (nodeStyle.flexDirection === 'column') {
                    nodeStyle.justifyContent = textAlign === 'left' ? 'flex-start' : textAlign === 'center' ? 'center' : 'flex-end'; // Set horizontal alignment for column layout
                } else {
                    nodeStyle.alignItems = textAlign === 'left' ? 'flex-start' : textAlign === 'center' ? 'center' : 'flex-end'; // Set horizontal alignment for row layout
                } */

                let verticalAlign = 'top'; // Default vertical alignment
                if (field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.top"]?.isDefault ||
                    (field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.top"]?.value
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.top"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.top"]?.value?.toLowerCase())
                ) {
                    verticalAlign = 'flex-start'; // Use flex-start for top alignment
                }
                if (field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.middle"]?.isDefault ||
                    (field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.middle"]?.value
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.middle"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.middle"]?.value?.toLowerCase())
                ) {
                    verticalAlign = 'center'; // Use center for middle alignment
                }
                if (field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.bottom"]?.isDefault ||
                    (field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.bottom"]?.value
                    && getCustomisationValue(customisationVars, field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.bottom"]?.dataLink, index, forceComponentVarKey, node)?.toString()?.toLowerCase() === field?.["customisation-module-typography-text-alignment.vertical"]?.["customisation-module-typography-text-alignment-vertical.bottom"]?.value?.toLowerCase())
                ) {
                    verticalAlign = 'flex-end'; // Use flex-end for bottom alignment
                }
                if (nodeStyle.flexDirection === 'column') {
                    nodeStyle.justifyItems = verticalAlign; // Set vertical alignment for column layout
                } else {
                    nodeStyle.alignItems = verticalAlign; // Set vertical alignment for row layout
                }
            }
        }
        // Note alignment not implemented yet, but it has 2 fields, horizontal and vertical alignment
        // Similarly Font is also a double field, with font family and font weight
    }
}

const applyShadowStyle = (shadowConfig, nodeStyle, customisationVars, previewScale, campaignData, forceComponentVarKey, node, index = 0, applyScale = 1) => {
    console.log("Applying shadow style for shadowConfig:", shadowConfig, nodeStyle, customisationVars);
    let shadowColor = '#000000'; // Default shadow color
    let shadowOpacity = 1;
    let shadowOffsetX = null;
    let shadowOffsetY = null;
    let shadowBlur = 5;
    let shadowSpread = 0;
    let shadowInset = false;
    for (let i = 0; i < shadowConfig.fields.length; i++) {
        const field = shadowConfig.fields[i];
        // console.log("shadow Processing field:", field);
        WORKING_ON_NODE_DATA.fieldData = field; // Store the field data for later use
        if (field.dataLink) {
            const value = getCustomisationValue(customisationVars, field.dataLink, index, forceComponentVarKey, node);
            // console.log(`shadow Field ${field.field} value from customisationVars ${field.dataLink}:`, value);
            if (value !== null && value !== undefined) {
                switch (field.field) {
                    case 'customisation-module-shadow-color':
                        if (node?.dontVisualiseModuleSettings?.shadow?.color !== true) {
                            shadowColor = COLOUR_NAME_TO_COLOUR_HEX(value, campaignData) || '#000000';
                        }
                        break;
                    case 'customisation-module-shadow-opacity':
                        if (node?.dontVisualiseModuleSettings?.shadow?.opacity !== true) {
                            shadowOpacity = parseFloat(value / 100);
                        }
                        break;
                    case 'customisation-module-shadow-offset-x':
                    case 'customisation-module-shadow-position-x':
                        if (node?.dontVisualiseModuleSettings?.shadow?.offsetX !== true) {
                            shadowOffsetX = parseFloat(value) * previewScale * applyScale;
                        }
                        break;
                    case 'customisation-module-shadow-offset-y':
                    case 'customisation-module-shadow-position-y':
                        if (node?.dontVisualiseModuleSettings?.shadow?.offsetY !== true) {
                            shadowOffsetY = parseFloat(value) * previewScale * applyScale;
                        }
                        break;
                    case 'customisation-module-shadow-blur':
                        if (node?.dontVisualiseModuleSettings?.shadow?.blur !== true) {
                            shadowBlur = parseFloat(value) * previewScale * applyScale;
                        }
                        break;
                    case 'customisation-module-shadow-spread':
                        if (node?.dontVisualiseModuleSettings?.shadow?.spread !== true) {
                            shadowSpread = parseFloat(value) * previewScale * applyScale;
                        }
                        break;
                    case 'customisation-module-shadow-inset':
                        if (node?.dontVisualiseModuleSettings?.shadow?.inset !== true) {
                            shadowInset = value === true || value.toString().toLowerCase() === 'true';
                        }
                        break;
                    default:
                        // console.warn(`Unknown shadow field: ${field.field}`);
                        break;
                }
            }
        } else {
            switch (field.field) {
                case 'customisation-module-shadow-position':
                    if (node?.dontVisualiseModuleSettings?.shadow?.offsetX !== true) {
                        shadowOffsetX = parseFloat(field?.["customisation-module-shadow-position-x"]?.dataLink ? getCustomisationValue(customisationVars, field["customisation-module-shadow-position-x"].dataLink, index, forceComponentVarKey, node) : 0) * previewScale * applyScale;
                    }
                    if (node?.dontVisualiseModuleSettings?.shadow?.offsetY !== true) {
                        shadowOffsetY = parseFloat(field?.["customisation-module-shadow-position-y"]?.dataLink ? getCustomisationValue(customisationVars, field["customisation-module-shadow-position-y"].dataLink, index, forceComponentVarKey, node) : 0) * previewScale * applyScale;
                    }
                    break;
                case 'customisation-module-shadow-spread':
                    if (node?.dontVisualiseModuleSettings?.shadow?.spread !== true) {
                        shadowSpread = parseFloat(field?.["customisation-module-shadow-spread"]?.dataLink ? getCustomisationValue(customisationVars, field["customisation-module-shadow-spread"].dataLink, index, forceComponentVarKey, node) : 0) * previewScale * applyScale;
                    }
                    break;
                default:
                    // console.warn(`Unknown shadow field: ${field.field}`);
                    break;
            }
        }
    }
    // Now apply the shadow to the nodeStyle
    const rgbaColor = HEX_TO_RGBA(shadowColor, shadowOpacity);
    if (shadowConfig?.moduleSettings?.applyToContent) {
        nodeStyle.textShadow = `${shadowOffsetX ?? shadowSpread}px ${shadowOffsetY ?? shadowSpread}px ${shadowBlur}px ${rgbaColor}`;
    } else {
        nodeStyle.boxShadow = `${shadowInset ? 'inset ' : ''}${shadowOffsetX}px ${shadowOffsetY}px ${shadowBlur}px ${shadowSpread}px ${rgbaColor}`;
    }
}

const VisualisedNode = (props) => {
    // console.log("VisualisedNode props:", props);
    const dontVisualiseModuleSettings = props?.dontVisualiseModuleSettings ?? props.node?.dontVisualiseModuleSettings;

    const campaignData = props.campaignData;
    const { style, editingTextContentData, previewScale } = props;
    let node = props.node;

    const applyScale = node?.applyScale ?? props?.applyScale ?? 1;
    const [refreshContent, setRefreshContent] = useState(false);
    useEffect(() => {
        setRefreshContent(true);
        const timer = setTimeout(() => {
            setRefreshContent(false);
        }, 10);
        return () => clearTimeout(timer);
    }, [applyScale, previewScale, props.imageMode]);

    const dataIndex = props.forceDataIndex ?? props.dataIndex ?? (props?.activeNode?.parent === props?.node && props?.activeNode?.dataIndex ? props.activeNode.dataIndex : props.index ?? 0);
    let isDynamicSubNode = (props?.activeNode?.parent === props?.node && props?.activeNode?.dataIndex !== undefined) ? true : false;
    if (isDynamicSubNode) {
        node = node.subNodes ? node.subNodes[dataIndex] : node;
        isDynamicSubNode = false; // We only want to do this once
    }
    // console.log("Rendering VisualisedNode for node:", node, props.activeNode, "dataIndex:", dataIndex, "isDynamicSubNode:", isDynamicSubNode);

    const textEditMode = props?.textEditMode ?? false;
    const textEditModeFieldPath = props?.textEditModeFieldPath ?? null;
    const getTextEditModeContent = () => (getCustomisationValue(node?.customisationVars, textEditModeFieldPath, props.index ?? 0, props?.forceComponentVarKey ?? null, node) ?? '');
    const textEditModeContentData = { module: node, contentConfig: {dataLink: textEditModeFieldPath}, content: [<>{nl2br(getTextEditModeContent())}</>] }

    if (node?.config?.groupSettings?.preserveSpaceWhileDragging !== true && (node === props.draggingNode || (isDynamicSubNode && props.node === props.draggingNode?.parent))) {
        return null;
    }

    // Remember this for easy access, so we can post/pre-process data
    WORKING_ON_NODE_DATA.visualisedNodeVarKey = props.visualisedNodeVarKey;

    const nodeContent = [];
    const contentStyle = props.contentStyle || {};
    const contentInnerStyle = props.contentInnerStyle || props.innerContentStyle || {};
    const nodeStyle = style ? {...style} : {};

    nodeStyle.flexDirection = node?.config?.visualisationConfig?.direction === 'Top to Bottom' ? 'column' : 'row';
    if (node?.config?.visualisationConfig?.flex && node.config.visualisationConfig.flex.toLowerCase() !== 'auto') {
        switch (node.config.visualisationConfig.flex.toLowerCase()) {
            case 'shrink':
                nodeStyle.flexShrink = 1;
                nodeStyle.flexGrow = 0;
                break;
            case 'grow':
                nodeStyle.flexShrink = 0;
                nodeStyle.flexGrow = 1;
                break;
            default:
                nodeStyle.flexShrink = 0;
                nodeStyle.flexGrow = 0;
                break;
        }
    }
    nodeStyle.overflow = node?.config?.visualisationConfig?.overflow ?? 'hidden';
    if (node?.config?.visualisationConfig?.isFullScreen) {
        nodeStyle.width = '100%';
        nodeStyle.height = '100%';
    }
    if (textEditMode && props.editingTextContentData && textEditModeFieldPath === props.editingTextContentData.dataLink) {
        nodeStyle.flexShrink = 0;
        nodeStyle.flexGrow = 1;
    }
    let customVisualisedNodeConfig = null;
    let customVisualisedNodeKey = props?.forceComponentVarKey ?? null;
    let applyStylesToCustomComponent = false;
    if (props?.node?.config?.visualisationConfig?.visualisationComponent && !props.onlyStyleVisualisation) {
        const visualisationComponentName = props.node.config.visualisationConfig.visualisationComponent;
        if (visualisationComponentName) {
            customVisualisedNodeConfig = CUSTOM_COMPONENTS_LIST[visualisationComponentName];
            if (!customVisualisedNodeConfig?.render) {
                // console.warn(`Custom visualised node component not found: ${visualisationComponentName}`);
                customVisualisedNodeConfig = null; // Reset to null if not found
            } else {
                customVisualisedNodeKey = visualisationComponentName;
                // console.log(`Using custom visualised node component: ${visualisationComponentName}`);
                applyStylesToCustomComponent = props.node.config.visualisationConfig.applyVisualisationComponentStyles === true;
            }
        }
    }

    let hideElement = false;
    // Toggled off (ie. made invisible)
    if (!node?.config?.visualisationConfig?.reverseVisualisationToggle && node?.config?.visualisationConfig?.toggle && !getCustomisationValue(node.customisationVars, node?.config?.visualisationConfig?.toggle, dataIndex ?? 0, customVisualisedNodeKey, node)) {
        // return null;
        hideElement = true;
    }
    if (node?.config?.visualisationConfig?.reverseVisualisationToggle && node?.config?.visualisationConfig?.toggle && getCustomisationValue(node.customisationVars, node?.config?.visualisationConfig?.toggle, dataIndex ?? 0, customVisualisedNodeKey, node)) {
        // return null;
        hideElement = true;
    }
    if (node?.config?.visualisationConfig?.advancedVisualisationToggleLink && node?.config?.visualisationConfig?.advancedVisualisationToggleValue !== undefined && node?.config?.visualisationConfig?.advancedVisualisationToggleValue !== null) {
        const advancedToggleValue = getCustomisationValue(node.customisationVars, node.config.visualisationConfig.advancedVisualisationToggleLink, dataIndex ?? 0, customVisualisedNodeKey, node);
        if (
            (node?.config?.visualisationConfig?.advancedVisualisationToggleReverse !== true && 
                (advancedToggleValue === node.config.visualisationConfig.advancedVisualisationToggleValue || Number(advancedToggleValue) === Number(node.config.visualisationConfig.advancedVisualisationToggleValue) || advancedToggleValue?.toString() === node.config.visualisationConfig.advancedVisualisationToggleValue)
            ) || 
            (node?.config?.visualisationConfig?.advancedVisualisationToggleReverse === true && 
                (advancedToggleValue !== node.config.visualisationConfig.advancedVisualisationToggleValue && Number(advancedToggleValue) !== Number(node.config.visualisationConfig.advancedVisualisationToggleValue) && advancedToggleValue?.toString() !== node.config.visualisationConfig.advancedVisualisationToggleValue)
            )
        ) {
            // return null;
            hideElement = true;
        }
    }
    // Is this a node that only applies to certain steps?
    if (node?.config?.visualisationConfig?.restrictSteps && (node.config.visualisationConfig.startStep > props.timelinePlayheadStep || node.config.visualisationConfig.endStep < props.timelinePlayheadStep)) {
        // Outside of the steps this node applies to
        // return null;
        hideElement = true; 
    }
    if (hideElement) {
        if (node?.config?.visualisationConfig?.preserveDomSpace !== true) {
            return null;
        } else {
            nodeStyle.visibility = 'hidden'; // Hide the element but preserve its space in the layout
            nodeStyle.pointerEvents = 'none'; // Make sure the element is not interactive when hidden
        }
    }

    let scaledContent = false;
    if (!textEditMode && node?.config?.children && node.config.children.length > 0) {
        const children = node.config.children;
        for (let i = 0; i < children.length; i++) {

            let hideModule = false;
            if (children[i]?.moduleSettings?.visualisationToggle !== undefined && children[i]?.moduleSettings?.visualisationToggle !== null) {
                const toggleValue = getCustomisationValue(node.customisationVars, children[i].moduleSettings.visualisationToggle, dataIndex ?? 0, customVisualisedNodeKey, node);
                if (children[i].module === 'shadow') {
                    console.log(`SHADOW: Visualisation toggle value for module ${children[i].module} in node ${node.id}:`, toggleValue, children[i]?.moduleSettings);
                }
                if ((children[i]?.moduleSettings?.reverseVisualisationToggle === true && toggleValue) || (children[i]?.moduleSettings?.reverseVisualisationToggle !== true && !toggleValue)) {
                    hideModule = true;
                }
            }
            if (!hideModule) {
                if (children[i]?.moduleSettings?.advancedVisualisationToggleLink && children[i]?.moduleSettings?.advancedVisualisationToggleValue !== undefined && children[i]?.moduleSettings?.advancedVisualisationToggleValue !== null) {
                    const advancedToggleValue = getCustomisationValue(node.customisationVars, children[i].moduleSettings.advancedVisualisationToggleLink, dataIndex ?? 0, customVisualisedNodeKey, node);
                    if (((advancedToggleValue === children[i].moduleSettings.advancedVisualisationToggleValue || Number(advancedToggleValue) === Number(children[i].moduleSettings.advancedVisualisationToggleValue) || advancedToggleValue?.toString() === children[i].moduleSettings.advancedVisualisationToggleValue) && children[i]?.moduleSettings?.advancedVisualisationToggleReverse !== true) || ((advancedToggleValue !== children[i].moduleSettings.advancedVisualisationToggleValue && Number(advancedToggleValue) !== Number(children[i].moduleSettings.advancedVisualisationToggleValue) && advancedToggleValue?.toString() !== children[i].moduleSettings.advancedVisualisationToggleValue) && children[i]?.moduleSettings?.advancedVisualisationToggleReverse === true)) {
                        hideModule = true;
                    }
                }
            }

            if (children[i].type === 'module' && children[i]?.moduleSettings?.visualise !== false && !hideModule) {
                switch (children[i].module) {
                    case 'position':
                        if (dontVisualiseModuleSettings?.position !== true && !props.onlyStyleVisualisation) {
                            addPositionStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0, props.applyScaleToPosition !== false ? applyScale : 1, props?.forcePosition ?? node?.forcePosition ?? null, props?.initialXOffset ?? node?.initialXOffset ?? null, props?.initialYOffset ?? node?.initialYOffset ?? null);
                        }
                        break;
                    case 'dimensions':
                        if (dontVisualiseModuleSettings?.dimensions !== true && !props.onlyStyleVisualisation) {
                            addDimensionsStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0, applyScale);
                        }
                        break;
                    case 'appearance':
                        if (!customVisualisedNodeKey || applyStylesToCustomComponent) {
                            if (dontVisualiseModuleSettings?.appearance !== true) {
                                addAppearanceStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0, applyScale);
                            }
                        }
                        break;
                    case 'border':
                        if (!customVisualisedNodeKey || applyStylesToCustomComponent) {
                            if (dontVisualiseModuleSettings?.border !== true) {
                                addBorderStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0, applyScale);
                            }
                        }
                        break;
                    case 'fill':
                        if (!customVisualisedNodeKey || applyStylesToCustomComponent) {
                            if (dontVisualiseModuleSettings?.fill !== true && dontVisualiseModuleSettings?.background !== true) {
                                addFillStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0);
                            }
                        }
                        break;
                    case 'padding':
                        if (!customVisualisedNodeKey || applyStylesToCustomComponent) {
                            if (dontVisualiseModuleSettings?.padding !== true) {
                                addPaddingStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0, applyScale);
                            }
                        }
                        break;
                    case 'typography':
                        if (!customVisualisedNodeKey || applyStylesToCustomComponent) {
                            if (dontVisualiseModuleSettings?.typography !== true) {
                                addTypographyStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0, applyScale);
                            }
                        }
                        break;
                    case 'shadow':
                        if (!customVisualisedNodeKey || applyStylesToCustomComponent) {
                            if (dontVisualiseModuleSettings?.shadow !== true) {
                                applyShadowStyle(children[i], nodeStyle, node.customisationVars, previewScale, campaignData, customVisualisedNodeKey, node, dataIndex ?? 0, applyScale);
                            }
                        }
                        break;
                    case 'copy':
                        if ((!customVisualisedNodeKey || applyStylesToCustomComponent || props.contentNode) && (!props.fixedContent || props.fixedContent === children[i].dataLink)) {
                            const findFixContent = (child) => {
                                let fixedContent = null
                                if (!child.dataLink && child.fields && child.fields.length > 0) {
                                    for (let j = 0; j < child.fields.length; j++) {
                                        const field = child.fields[j];
                                        if (field.customFieldConfig?.fixedValue) {
                                            fixedContent = field.customFieldConfig.fixedValue;
                                            break;
                                        }
                                    }
                                }
                                return fixedContent;
                            }
                            nodeContent.push(
                                { module: node, contentConfig: children[i], content: <>{nl2br(getCustomisationValue(node.customisationVars, children[i].dataLink, dataIndex ?? 0, customVisualisedNodeKey, node) ?? findFixContent(children[i]))}</> }
                            )
                            // console.log("Copy module found, content:", nodeContent[nodeContent.length - 1]);
                        }
                        break;
                    case 'custom':
                        if ((!customVisualisedNodeKey || applyStylesToCustomComponent || props.contentNode) && (!props.fixedContent || props.fixedContent === children[i].dataLink)) {
                            // console.log("Custom module found, processing:", children[i], node, props.activeNode);
                            const customContent = getCustomModuleContent(children[i], node.customisationVars, props.imageMode, previewScale, dataIndex ?? 0, node, contentStyle, applyScale, refreshContent, props.applyRotation);
                            if (customContent && Array.isArray(customContent) && customContent.length > 0) {
                                scaledContent = true;
                                nodeContent.push({ module: node, contentConfig: children[i], content: customContent });
                                // console.log("Custom module content:", nodeContent);
                            }
                        }
                        break;
                    default:
                        // console.warn(`Unknown module type: ${children[i].module}`);
                        break;
                }
            }
        }
    }

    if (node === props.draggingNode || (isDynamicSubNode && props.node === props.draggingNode?.parent)) {
        nodeStyle.pointerEvents = 'none'; // Disable pointer events while dragging
        nodeStyle.opacity = 0; // Reduce opacity while dragging
    }

    const nodeCanBeSelected = props.focusEditingOnNode === null || props.forceSelectable || props.focusEditingOnNode === node || findSubNode(props.focusEditingOnNode, node?.name) !== null;

    // console.log("Visualised node children:", props.children);
    return (
        <>
            {/*props.node === props.visualisedNode && props.topLevel && props.clickable !== false && node.subNodes && node.subNodes.length > 0 &&
                <div className="v2-visualised-top-node-easy-select"
                    onClick={
                        (!editingTextContentData && props.clickable !== false) ?
                            (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (!props.draggingActive.current) {
                                    props.draggingCancelled.current = true;
                                    props.activateNodeFunction(node)
                                }
                            }
                            : null
                    }
                ></div>
            */}

            <div className={`v2-visualised-node v2-node-hoverable${node === props.draggingNode ? ' v2-dragging-node' : ''}`}
                style={nodeStyle}
                id={node?.id}
                onClick={
                    (nodeCanBeSelected && !editingTextContentData && props.clickable !== false) ?
                        (e) => {
                            console.log("VisualisedNode onClick for node, activate node:", node, e, document.getElementById(node?.id));
                            e.stopPropagation();
                            e.preventDefault();
                            if (!props.draggingActive.current) {
                                props.draggingCancelled.current = true;
                                props.activateNodeFunction(isDynamicSubNode ? node.subNodes[dataIndex] : node)
                            }
                        }
                        : null
                }
                onMouseDown={(nodeCanBeSelected && !textEditMode && (props.topLevel || canNodeBeMovedOrResized(isDynamicSubNode ? node.subNodes[dataIndex] : node).moveable) && !editingTextContentData && props.clickable !== false) ? (e) => props.startDraggingNode(e, isDynamicSubNode ? node.subNodes[dataIndex] : node, dataIndex) : null}
                // onMouseUp={props.topLevel ? (e) => {draggingCancelled.current = true;} : null}
                // This was on the capture phase for some reason, if we get other issues with highlighting we can try that again
                onMouseOver={(nodeCanBeSelected && !textEditMode && props.clickable !== false) ? (e) => props.highlightHoveredNode(e, node, false/*scaledContent*/) : null}
                onMouseLeave={(nodeCanBeSelected && !textEditMode && props.clickable !== false) ? (e) => props.unhighlightHoveredNode(e, node) : null}
            >
                {!textEditMode && customVisualisedNodeConfig && !props.contentNode &&
                    customVisualisedNodeConfig.render({...props, topLevel: false})
                }
                {!textEditMode && !props.onlyStyleVisualisation && !customVisualisedNodeConfig && !props.children && node.subNodes && node.subNodes.length > 0 &&
                    node.subNodes.map((subNode, index) => {
                        if (subNode.isVisualised && subNode?.groupSettings?.visualise !== false && !node.dynamicSubNodes) {
                            return (
                                <VisualisedNode
                                    {...props}
                                    key={node.id + '_' + index}
                                    node={subNode}
                                    activeNode={props.activeNode}
                                    visualisedNode={props.visualisedNode}
                                    timelinePlayheadStep={props.timelinePlayheadStep}
                                    timelinePlayheadLabel={props.timelinePlayheadLabel}
                                    activateNodeFunction={props.activateNodeFunction}
                                    topLevel={false}
                                    editingTextContentData={props.editingTextContentData}
                                    setEditingTextContentData={props.setEditingTextContentData}
                                    highlightHoveredNode={props.highlightHoveredNode}
                                    unhighlightHoveredNode={props.unhighlightHoveredNode}
                                    startDraggingNode={props.startDraggingNode}
                                    draggingActive={props.draggingActive}
                                    draggingCancelled={props.draggingCancelled}
                                    draggingNode={props.draggingNode}
                                    contentClicked={props.contentClicked}
                                    previewScale={props.previewScale}
                                    clickable={props.clickable}
                                    campaignData={campaignData}
                                    imageMode={subNode?.config?.visualisationConfig?.isFullScreen ? IMAGE_MODES.fillArea : IMAGE_MODES.naturalSize}
                                    // index={node.subNodes.indexOf(props?.activeNode) >= 0 && props?.activeNode?.dataIndex ? props.activeNode.dataIndex : 0}
                                />
                            );
                        } else {
                            return null;
                        }
                    })
                }
                {!textEditMode &&!props.children && nodeContent.length > 0 && /* !refreshContent && */
                    nodeContent.map(
                        (contentData, index) => {
                            if (props.editingTextContentData && contentData.contentConfig.dataLink === props.editingTextContentData.dataLink) {
                                return (
                                    <EditTextInPlace
                                        key={index}
                                        contentData={contentData}
                                        node={node}
                                        index={props.index ?? 0}
                                        customisationVars={node.customisationVars}
                                        updateCustomisationValue={updateCustomisationValue}
                                        getCustomisationValue={getCustomisationValue}
                                        editingTextContentData={props.editingTextContentData}
                                        setEditingTextContentData={props.setEditingTextContentData}
                                        placeholder={props.placeholder ?? ''}
                                    />
                                )
                            }
                            return (
                                <div style={{...contentStyle, width: '100%'}} className={`${node !== props.draggingNode && !editingTextContentData && props.className ? props.className : ''}`} >
                                    <div key={index} className={`${(!props.editingTextContentData && props.clickable !== false && contentData.contentConfig.dataLink) ? 'v2-node-content-hoverable' : ''}`} style={{...contentInnerStyle, width: '100%'}} onClick={(!props.editingTextContentData && props.clickable !== false && contentData.contentConfig.dataLink) ? (e) => props.contentClicked(e, isDynamicSubNode ? node.subNodes[dataIndex] : node, index, contentData) : null}>
                                        {props.beforeContent && <>{props.beforeContent}</>}
                                        {contentData.content}
                                        {props.afterContent && <>{props.afterContent}</>}
                                    </div>
                                </div>
                            )
                        }
                    )
                }
                {textEditMode &&
                    <>
                        {((props.editingTextContentData && textEditModeFieldPath === props.editingTextContentData.dataLink) || props.forceEdit) &&
                            <EditTextInPlace
                                contentData={textEditModeContentData}
                                node={node}
                                index={props.index ?? 0}
                                multiline={props.multiline ?? false}
                                customisationVars={node.customisationVars}
                                updateCustomisationValue={updateCustomisationValue}
                                getCustomisationValue={getCustomisationValue}
                                editingTextContentData={props.editingTextContentData}
                                setEditingTextContentData={props.setEditingTextContentData}
                                forceEdit={props.forceEdit}
                                placeholder={props.placeholder ?? ''}
                                valueChangedCallback={props.valueChangedCallback}
                            />
                        }
                        {((!props.editingTextContentData || textEditModeFieldPath !== props.editingTextContentData.dataLink) && !props.forceEdit) && 
                            <div style={{...contentStyle, width: '100%'}} className={`${node !== props.draggingNode && !editingTextContentData && props.className ? props.className : ''}`}>
                                <div className={`${(!props.editingTextContentData && props.clickable !== false) ? 'v2-node-content-hoverable' : ''}`} style={{...contentInnerStyle, width: '100%'}} onClick={(!props.editingTextContentData && props.clickable !== false) ? (e) => {props.contentClicked(e, props.textEditModeContentNode, props.index ?? 0, textEditModeContentData, true, (props?.selectOnly ?? false)); props.textEditStartedCallback?.();} : null}>
                                    {props.beforeContent && <>{props.beforeContent}</>}
                                    {props?.content ?? textEditModeContentData.content[0]}
                                    {props.afterContent && <>{props.afterContent}</>}
                                </div>
                            </div>
                        }
                    </>
                }
                {props.children}
            </div>
        </>
    );
}

const EditTextInPlace = (props) => {
    const [textValue, setTextValue] = useState(getCustomisationValue(props.node.customisationVars, props.contentData.contentConfig.dataLink, props.index) || '');
    const multiline = props.contentData.contentConfig.multiline || props.multiline || false;
    const handleChange = (e) => {
        setTextValue(e.target.value);
    }
    const handleBlur = () => {
        if (textValue.trim() !== '') {
            props.updateCustomisationValue(props.node.customisationVars, props.contentData.contentConfig.dataLink, textValue, props.index, props.forceComponentVarKey ?? null, props.node ?? null, props.visualisationExtraData ?? null, props.valueChangedCallback ?? null);
        } else {
            // If the text is empty, we can remove the content
            props.updateCustomisationValue(props.node.customisationVars, props.contentData.contentConfig.dataLink, '', props.index, props.forceComponentVarKey ?? null, props.node ?? null, props.visualisationExtraData ?? null, props.valueChangedCallback ?? null);
        }
        props.setEditingTextContentData(null); // Exit edit mode
    }
    const handleKeyDown = (e) => {
        if (!multiline && e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission
            handleBlur(); // Save changes on Enter
        } else if (e.key === 'Escape') {
            e.preventDefault(); // Prevent form submission
            props.setEditingTextContentData(null); // Exit edit mode without saving
        }
    }
    if (multiline) {
        // For multiline text, we can use a textarea
        return (
            <textarea
                className='v2-editable-textarea'
                value={textValue}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                autoFocus
                placeholder={props.placeholder ?? ''}
            />
        );
    } else {
        // For single line text, we can use an input
        return (
            <input
                className='v2-editable-input'
                type='text'
                value={textValue}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                autoFocus
                placeholder={props.placeholder ?? ''}
            />
        );
    }
}

export default VisualisedNode;